import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import SubmitButton from './fields/SubmitButton';
import FulltextInput from './fields/FulltextInput';
import DateRangePicker from './fields/DateRangePicker';
import {useFilter} from '../../api/hooks';
import {generateRoute, useRoutes} from '../../routing/RouteProvider';
import Loader from '../pages/Loader';
import Error from '../pages/Error';
import {Link} from 'react-router-dom';
import {useHistory} from 'react-router';
import {objRemoveEmptyAndFalseyProperties} from '../../helper';
import Banner from '../sections/Banner';
import {useTranslation} from '../../config/TranslationProvider';

const HeaderFilter = () => {
    const hideBannerUntil = window.localStorage.getItem('hideBannerUntil');
    const currentTime = new Date().getTime();
    const hideBanner = hideBannerUntil && parseInt(hideBannerUntil) > currentTime;
    const [showBanner, setShowBanner] = useState(!hideBanner);

    const history = useHistory();
    const routes = useRoutes();
    const filterPath = query => generateRoute(routes, 'events', {filter: query});
    const onSubmit = formData => {
        objRemoveEmptyAndFalseyProperties(formData);
        const url = filterPath(formData);
        history.push(url);
    };

    const {register, handleSubmit} = useForm();
    const {data: filters, isLoading, error} = useFilter();

    const fulltextSearchAriaLabel = useTranslation('fulltext_search_events');
    const homepageFilterDescription = useTranslation('homepage_filter_description');

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return (
        <>
            <p id="homepage-filter-description" className="sr-only">
                {homepageFilterDescription}
            </p>
            <form className="search_form" onSubmit={handleSubmit(onSubmit)} aria-describedby="homepage-filter-description">
                <div className="atbd_seach_fields_wrapper">

                    <div className="single_search_field">
                        <FulltextInput
                            register={register}
                            ariaLabel={fulltextSearchAriaLabel}
                        />
                    </div>

                    <DateRangePicker register={register} inline={true} />

                    <div className="atbd_submit_btn">

                        <SubmitButton
                            className="btn btn-block btn-gradient btn-gradient-two btn-md btn_search"
                        />

                    </div>

                </div>
            </form>

            {showBanner && <Banner setShowBanner={setShowBanner} />}

            <div className="directory_home_category_area">
                <ul className="categories">
                    {filters.map((value, key) => (
                        <li key={key}>
                            <Link
                                to={'events?filter=' + value.slug}
                                className="filter-card"
                            >
                                {value.filter_title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default HeaderFilter;
